import React from 'react'

import WithdrawalRateGraph from './WithdrawalRateGraph'
import { useScrollToFragment } from '../../../../shared/utils/hooks'

const App = props => {
  useScrollToFragment()
  const { contentTitle, content } = props.content
  return (
    <div className='pt-withdrawal-graph u-sizeConstrained u-paddingHoriz14gu u-bgColorLight pt-break-before-avoid pt-break-after pt-break-between-avoid'>
      <WithdrawalRateGraph contentTitle={contentTitle} content={content} />
    </div>
  )
}

export default App
